import moment from "moment";

export const validatorPositive = value => {
  if (value >= 0) {
    return true;
  }
  return false;
};

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  // const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*();:]).{6,}/
  const regExp = /(?=.*\d)(?=.*[a-zA-Z]).{6,}/;
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password);
  return validPassword;
};

export const validatorConfirmPassword = (value, [password]) =>
  value === password;

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/;
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum);
  return validCreditCard;
};

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
  /* eslint-enable no-useless-escape */
  return re.test(val);
};

export const validatorCheckinTime = time => {
  if (time === null) return null;
  const timepickerFormat = "HH:mm:ss";
  const minTime = moment("16:00:00", timepickerFormat);
  const maxTime = moment("02:00:00", timepickerFormat);
  return !moment(time, timepickerFormat).isBetween(
    maxTime,
    minTime,
    null,
    "()"
  );
};

export const validatorCheckoutTime = time => {
  if (time == null) return null;
  const timepickerFormat = "HH:mm:ss";
  const minTime = moment("00:00:00", timepickerFormat);
  const maxTime = moment("10:00:00", timepickerFormat);
  return moment(time, timepickerFormat).isBetween(minTime, maxTime, null, "[]");
};

// The valid parameter is coming from the vue-phone-number-input, where
// the phone number has already been validated
export const validatorPhone = (value, [valid]) =>
  valid === "true" || valid === true;

export const validatorPolicy = accepted => !!accepted;

export const validatorPastDate = value => {
  if (value == null) return null;
  const dateFormat = "YYYY-MM-DD";
  const formattedDate = moment(value, dateFormat);
  const today = moment();
  const isBefore = formattedDate.isBefore(today, "day");
  return isBefore;
};

export const validatorTwoLastNames = lastName => {
  if (lastName === undefined || lastName === null || lastName.trim() === '') {
    return false
  }

  // Clean up and normalize the input
  const normalizedLastName = lastName.trim()

  // Split the last name by spaces for further processing
  const lastNameParts = normalizedLastName.split(/\s+/)

  if (lastNameParts.length <= 1) {
    // If there's only one part, it's not a compound last name
    return false
  }
  
  // List of common prepositions in last names across different languages
  const prepositions = [
    // Espanyol / Català
    "de",
    "del",
    "de la",
    "de las",
    "de los",
    "y",
    "i",

    // Francès
    "de",
    "du",
    "des",
    "de La",
    "de le",

    // Alemany
    "von",
    "zu",
    "von und zu",
    "von der",
    "von dem",
    "von den",
    "auf",

    // Holandès
    "van",
    "van de",
    "van der",
    "van den",
    "ten",
    "ter",
    "te",
    "op den",
    "aan de",

    // Italià
    "di",

    // Portuguès
    "de",
    "da",
    "do",
    "dos",
    "das"
  ]

  // First, check for compound multi-word prepositions
  // For example, check if "de la" in "de la hoz" is treated as a single preposition
  for (const preposition of prepositions) {
    if (preposition.includes(' ')) {
      // Handle multi-word prepositions like "de la", "van der", etc.
      const prepositionRegex = new RegExp(`^${preposition}\\s+\\S+$`, 'i')
      if (prepositionRegex.test(normalizedLastName)) {
        // If the string is just a preposition plus one word (e.g., "de la hoz"), it's not a compound last name
        return false
      }
    }
  }

  // Check if the last part is a preposition (e.g., "Serra i")
  // If so, it's not a valid compound last name
  if (prepositions.includes(lastNameParts[lastNameParts.length - 1].toLowerCase())) {
    return false
  }

  // Identify all real last names (non-prepositions)
  const realLastNames = []
  let i = 0

  while (i < lastNameParts.length) {
    // Check for multi-word prepositions first
    let foundMultiWordPreposition = false
    for (const preposition of prepositions) {
      if (preposition.includes(' ')) {
        const prepParts = preposition.toLowerCase().split(/\s+/)
        if (i + prepParts.length <= lastNameParts.length) {
          // Check if we have a matching sequence
          let matches = true
          for (let j = 0; j < prepParts.length; j++) {
            if (lastNameParts[i + j].toLowerCase() !== prepParts[j]) {
              matches = false
              break
            }
          }
          if (matches) {
            // We found a multi-word preposition
            foundMultiWordPreposition = true
            // Skip all parts of this preposition
            i += prepParts.length
            break
          }
        }
      }
    }
    
    if (foundMultiWordPreposition) {
      // If we just processed a multi-word preposition, continue to the next part
      continue
    }

    // Check if current part is a single-word preposition
    const currentPart = lastNameParts[i].toLowerCase()
    if (prepositions.includes(currentPart)) {
      // It's a preposition, move to the next part
      i++
      continue
    }

    // It's not a preposition, so it's a real last name part
    realLastNames.push(lastNameParts[i])
    i++
  }

  // We need at least 2 real last names for a compound last name
  return realLastNames.length >= 2
}

export const validatorDNI = dni => {
  if (dni === undefined || dni === null || dni.trim() === '') {
    return false
  }

  // Clean up and normalize the input
  const normalizedDNI = dni.trim()

  // Check if the input is a valid DNI format
  const dniRegex = /^[0-9]{8}[A-Z]$/
  if (!dniRegex.test(normalizedDNI)) {
    return false
  }

  // Extract the number and letter from the DNI
  const dniNumber = parseInt(normalizedDNI.slice(0, -1), 10)
  const dniLetter = normalizedDNI.slice(-1).toUpperCase()

  // Calculate the expected letter based on the number
  const letters = "TRWAGMYFPDXBNJZSQVHLCKE"
  const expectedLetter = letters[dniNumber % 23]

  // Compare the expected letter with the provided letter
  return expectedLetter === dniLetter
}

export const validatorNIE = nie => {
  if (nie === undefined || nie === null || nie.trim() === '') {
    return false
  }

  // Clean up and normalize the input
  const normalizedNIE = nie.trim().toUpperCase()
  
  // Check if the input is a valid NIE format
  const nieRegex = /^[XYZ][0-9]{7}[A-Z]$/
  if (!nieRegex.test(normalizedNIE)) {
    return false
  }
  
  // Replace the initial letter with its corresponding number
  let nieNumberStr = normalizedNIE.slice(1, -1)
  const firstChar = normalizedNIE.charAt(0)
  
  // Replace X, Y, Z with 0, 1, 2
  if (firstChar === 'X') nieNumberStr = '0' + nieNumberStr
  else if (firstChar === 'Y') nieNumberStr = '1' + nieNumberStr
  else if (firstChar === 'Z') nieNumberStr = '2' + nieNumberStr
  
  const nieNumber = parseInt(nieNumberStr, 10)
  const nieLetter = normalizedNIE.slice(-1)
  
  // Calculate the expected letter based on the number
  const letters = "TRWAGMYFPDXBNJZSQVHLCKE"
  const expectedLetter = letters[nieNumber % 23]
  
  // Compare the expected letter with the provided letter
  return expectedLetter === nieLetter
}

export const validatorCIF = cif => {
  if (!cif || typeof cif !== 'string') return false

  const normalizedCIF = cif.toUpperCase().trim()

  if (!/^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/.test(normalizedCIF)) {
    return false
  }

  const letters = 'JABCDEFGHI'
  const cifLetter = normalizedCIF.charAt(0)
  const number = normalizedCIF.substr(1, 7)
  const control = normalizedCIF.substr(8, 1)

  let sumA = 0 // sum of even positions
  let sumB = 0 // sum of odd positions (each digit doubled, then sum digits if result > 9)

  for (let i = 0; i < number.length; i++) {
    let n = parseInt(number.charAt(i), 10)
    if ((i + 1) % 2 === 0) {
      sumA += n
    } else {
      let prod = n * 2
      sumB += prod > 9 ? Math.floor(prod / 10) + (prod % 10) : prod
    }
  }

  const total = sumA + sumB
  const controlDigit = (10 - (total % 10)) % 10
  const controlLetter = letters[controlDigit]

  // Determinar el tipus de control segons la lletra inicial
  const letterControl = /[PQRSNW]/.test(cifLetter)
  const digitControl = /[ABEH]/.test(cifLetter)

  if (digitControl) return control == controlDigit.toString()
  if (letterControl) return control == controlLetter
  return control == controlLetter || control == controlDigit.toString()
}

export const validatorSoporteDNI = idSupportNumber => {
  if (idSupportNumber === undefined || idSupportNumber === null || idSupportNumber.trim() === '') {
    return false;
  }

  // Clean up and normalize the input
  const normalizedIdSupport = idSupportNumber.trim().toUpperCase();
  
  // Check if the input follows the format: 3 letters followed by 6 digits
  const idSupportRegex = /^[A-Z]{3}[0-9]{6}$/;
  
  return idSupportRegex.test(normalizedIdSupport);
};

export const validatorSoporteNIE = idSupportNumber => {
  if (idSupportNumber === undefined || idSupportNumber === null || idSupportNumber.trim() === '') {
    return false;
  }

  // Clean up and normalize the input
  const normalizedIdSupport = idSupportNumber.trim().toUpperCase();
  
  // Check if the input follows the format: 'E' or 'C' followed by 8 digits
  const idSupportRegex = /^[EC][0-9]{8}$/;
  
  return idSupportRegex.test(normalizedIdSupport);
};


